import React from 'react'
import { Link } from 'react-router-dom';


function ServiceEleven() {
    return (
        <div>
            {/* rts service post area  Start*/}
            <div className="rts-service-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-title-area service text-center">
                                <p className="pre-title">Our Services</p>
                                <h2 className="title">Accounting Services Designed for Modern Business</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid service-main plr--120-service mt--50 plr_md--0 pl_sm--0 pr_sm--0">
                    <div className="background-service row">
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner one">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/01.svg"
                                        alt="Bookkeeping and Management Accounts"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Bookkeeping and Management Accounts</h5>
                                    <p className="disc">
                                        Accurate books and clear monthly packs with P&L, balance sheet and cash flow. We reconcile banks, handle receipts and flag issues early so you always know where you stand.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner two">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/02.svg"
                                        alt="Payroll and Pensions"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Payroll and Pensions</h5>
                                    <p className="disc">
                                        Fully managed payroll with RTI submissions, payslips, statutory pay and auto enrolment. Staff are paid on time and records stay HMRC ready.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner three">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/03.svg"
                                        alt="Taxation and VAT"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Taxation and VAT</h5>
                                    <p className="disc">
                                        Corporation tax, self assessment, VAT returns and Making Tax Digital. We file on time, reduce errors and plan legally to lower liabilities.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner four">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/04.svg"
                                        alt="Business Advisory"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Business Advisory</h5>
                                    <p className="disc">
                                        Forecasts, budgets, pricing reviews, cost controls and funding readiness. Straightforward actions that protect cash and support growth.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner five">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/05.svg"
                                        alt="Company Formation and Compliance"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Company Formation and Compliance</h5>
                                    <p className="disc">
                                        Limited company setup, HMRC registrations, Companies House filings and company secretarial tasks.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner six">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/06.svg"
                                        alt="Platforms We Support"
                                    />
                                </div>
                                <div className="service-details">
                                    <h5 className="title">Platforms We Support</h5>
                                    <p className="disc">
                                        Xero, Sage and QuickBooks, including setup, cleanup and training. We help you choose the right platform for your business and migrate seamlessly.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/contactus'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                    </div>
                    <div className="row">
                        <div className="cta-one-bg col-12">
                            <div className="cta-one-inner">
                                <div className="cta-left">
                                    <h3 className="title">
                                        Ready to simplify your finances and support growth?
                                    </h3>
                                </div>
                                <div className="cta-right">
                                    <Link className="rts-btn btn-white" to={'/contactus'}>
                                        Book a Free Consultation
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts service post area ENd */}

        </div>
    )
}

export default ServiceEleven